<template>
  <b-row class="rotation-product" :class="{ 'selected-product': isSelected }">
    <b-col cols="3">
      <img
        :src="product.image"
        class="rotation-subscription-modal__form__product__image"
        :class="{ 'small-product-img': !isSelected }"
      >
    </b-col>
    <b-col cols="6">
      <b-row class="justify-center pt-3 pb-3">
        <h3 v-if="!loading">
          {{ product.title }} - $ {{ completePrice }}
        </h3>
      </b-row>
      <b-row
        v-show="modifiers.length > 0 && isSelected && !loading"
        class="w-100 mt-3 d-none d-md-block"
      >
        <b-row v-show="loading" key="loading" align-h="center" class="w-100">
          <SmallSpinner :size="50" centered />
        </b-row>
        <b-col>
          <product-modifiers
            v-show="modifiers.length > 0 && isSelected && !loading"
            v-model="modifiers"
            :validated.sync="modifiersValid"
            class="w-100"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="3" class="select-rotation-product" @click="emitSelection">
      <b-form-checkbox
        v-model="isSelected"
        class="mb-4"
        switch
        size="lg"
        @change="emitSelection"
      />
    </b-col>
    <template>
      <!-- This section for mobile version -->
      <div class="mx-2 w-100 d-md-none mt-3">
        <b-row v-show="loading" key="loading" align-h="center" class="w-100">
          <SmallSpinner :size="50" centered />
        </b-row>
        <b-row
          v-show="modifiers.length > 0 && isSelected && !loading"
          class="w-100 mt-3"
        >
          <b-col>
            <product-modifiers
              v-show="modifiers.length > 0 && isSelected && !loading"
              v-model="modifiers"
              :validated.sync="modifiersValid"
              class="w-100"
            />
          </b-col>
        </b-row>
      </div>
    </template>
  </b-row>
</template>

<script>
import { debounce } from 'lodash';
import { axios } from '^/axios';
import { configuration } from '~/configuration';
import SmallSpinner from '@/common/SmallSpinner.vue';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import ProductModifiers from '@/shop/product-partials/ProductModifiers.vue';

import {
  fetchSubscriptions,
  fetchRotatingSubscriptionProducts,
} from './rotating-subscription-service';

export default {
  name: 'RotationProduct',
  components: {
    SmallSpinner,
    ProductModifiers,
  },
  props: {
    product: {
      default: null,
      type: Object,
    },
    selected: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    const date = moment();
    return {
      min: date.toDate(),
      max: date.add(2, 'month').toDate(),
      loading: false,

      configuration,
      isSelected: false,
      modifiers: [],
      modifiersValid: null,
    };
  },
  async created() {
    await this.getModifiers(); //Get modifiers for each products from the begining
    if (this.product.modifiers) {
      this.modifiers = this.product.modifiers;
    }
    this.isSelected = this.selected;
  },

  computed: {
    ...mapGetters(['vendor', 'region']),
    completePrice() {
      //TODO: Update price in this.product props - not ready now
      // Add quantity
      let price = Number(this.product.unit_price);

      if (this.modifiers) {
        price =
          price +
          this.modifiers
            .map((x) =>
              x.items.reduce((a, item) => {
                if (item.is_floor_price)
                  return (a +=
                    Math.max(item.item_quantity, item.default_quantity) *
                    item.price_adjustment);

                return (a += item.item_quantity * item.price_adjustment);
              }, 0)
            )
            .reduce((a, b) => a + b, 0) *
            1; //TODO: multiply by product quantity (now it's 1)
        // this.product.quantityOrdered;
      }

      return price.toFixed(2);
    },
  },

  methods: {
    toggleSelection() {
      this.isSelected = !this.isSelected;
      this.emitSelection();
    },
    emitSelection() {
      // Emit event with the selected state and product data
      this.$emit('product-selected', {
        product: this.product,
        isSelected: this.isSelected,
      });
    },
    async getModifiers() {
      this.loading = true;
      try {
        this.modifiers = await axios.get(
          `/product/${this.product.product_uuid}/modifiers`
        );
        this.$emit('update-modifiers', {
          product: this.product,
          modifiers: this.modifiers,
        });
      } catch (e) {
        await this.$store.dispatch('alertError', ['danger', e.message]);
      } finally {
        this.loading = false;
      }
      return;
    },
  },
  watch: {
    modifiersValid(val) {
      this.$store.commit(
        'toggleModifierValidation',
        val.findIndex((x) => !x) === -1
      );
    },
    async isSelected(newVal, oldVal) {
      if (newVal && !this.modifiers.length) {
        await this.getModifiers();
      }
    },
    modifiers: {
      deep: true,
      handler(newModifiers) {
        newModifiers.forEach((modifier) => {
          if (!modifier.items) return;

          modifier.items.forEach((item) => {
            this.$watch(
              () => item.item_quantity,
              (newQuantity, oldQuantity) => {
                if (newQuantity !== oldQuantity) {
                  this.$emit('update-modifiers', {
                    product: this.product,
                    modifiers: newModifiers,
                  });
                }
              }
            );
          });
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.rotation-product img {
  border-radius: 16px;
}
.rotation-subscription-modal__form__product__image {
  transition: width 0.3s ease, height 0.3s ease;
}

.small-product-img {
  width: 60px;
  height: auto;
}

.rotation-subscription-modal__form__product__image:not(.small-product-img) {
  width: 100%;
  height: auto;
}
.rotation-product {
  border: 1px solid #e6dede;
  padding: 10px;
  transition: border 0.3s ease;
  margin-bottom: 5px;
  border-radius: 16px;
  margin: 10px 0px 10px 0px;
}

.rotation-product.selected-product {
  // border-color: rgb(67, 134, 67);
  border-color: #209a32;
}
.select-rotation-product {
  display: flex;
  justify-content: center;
  align-items: center;
}
.justify-center {
  justify-content: center;
}
</style>
